// extracted by mini-css-extract-plugin
export default {"coloredSpacer":"style_coloredSpacer__UkrgO","copyWrapper":"style_copyWrapper__kaOk3","alternateHeader":"style_alternateHeader__to44S"};